import React, { useState } from 'react';
import TokenExpired from './TokenExpired';
import FullLogo from '../images/DAFullLogo.png';
import TailwindModal from '../components/TailwindModal';
import SharedOnboardingForm from '../components/SharedOnboardingForm';
import { notify } from '../utils/ToastUtils';
import OnboardSuccess from './OnboardSuccess';
import { useOnboarding } from '../hooks/useOnboarding';
import { Loader2 } from 'lucide-react';

const fieldsToCheck = [
  // 1. Personal
  'BloodGroup', 'Salutation', 'Full_Name', 'Gender', 'Nationality', 'FathersName', 'MaritalStatus', 'DateOfBirth', 'address', 'pincode', 'Upload_Passport_Size_photo_Copy',
  // 2. Contact
  'PersonalEmail', 'MobileNumber', 'EmergencyContact', 'RelationshipOfEmergency',
  // 3. Bank
  'Bank_Name', 'BankBranch', 'BankAccountNumber', 'IFCCode', 'NameInBank',
  // 4. Professional
  'FreshEmployementForPf', 'PAN_Number', 'AADHAAR_Number', 'NamePerAadhaar', 'GenderPerAadhaar', 'Date_of_Birth_as_per_Aadhaar', 'Pan_Card_Upload', 'Aadhaar_Card_Upload',
  // 5. Education
  'TenthPassed', 'Tenth_Marksheet_Upload', 'TwelthPassed', 'Twelth_Marksheet_Upload'
];

function OnBoarding() {
  const onboardingProps = useOnboarding({ isUS: false, fieldsToCheck });
  const { isInitializing, isVaild, isSuccess, modal, setModal, checked, loading, type } = onboardingProps;

  const downloadFile = async (fileName) => {
       const fileUrl = `${process.env.REACT_APP_PUBLIC_URL}/public/onboarding_attachments/${fileName}`;
    try {
        const response = await fetch(fileUrl);

        if (!response.ok) {
        throw new Error("File not found or CORS blocked");
        }

        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
    } catch (error) {
        console.error("Download failed:", error);
    }
  };

  if (isInitializing) {
    return (
      <div className="min-h-screen bg-slate-50 flex flex-col justify-center items-center">
        <Loader2 className="h-10 w-10 text-blue-600 animate-spin mb-4" />
        <p className="text-slate-500 font-medium">Verifying details...</p>
      </div>
    );
  }

  return (
    <>
      {isVaild !== false && isVaild !== null ? isSuccess ? <OnboardSuccess /> :
        <div className="min-h-screen bg-slate-50">
          <header className="sticky top-0 z-50 bg-slate-50/90 backdrop-blur-md border-b border-slate-200/60 shadow-sm py-2">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex flex-col sm:flex-row justify-between items-center h-auto min-h-12 gap-3 sm:gap-0">
                <div className="flex items-center gap-4">
                  <img src={FullLogo} alt="Data Aces" className="h-8 sm:h-9 w-auto object-contain sm:border-r border-slate-300 sm:pr-4" />
                  <div className="hidden sm:block">
                    <h2 className="text-sm font-bold text-slate-800 m-0 leading-tight">Welcome to D-Aces! 👋</h2>
                    <p className="text-slate-500 m-0 text-xs mt-0.5">Let's get your onboarding started</p>
                  </div>
                </div>
                <div id="onboarding-progress-portal" className="w-full sm:w-auto"></div>
              </div>
            </div>
          </header>
          <main className="w-full max-w-7xl mx-auto px-0 sm:px-2 lg:px-4 pb-8 sm:pb-10 pt-5 flex justify-center">
            <SharedOnboardingForm
                isUS={false}
                isReadOnly={false}
                type={type}
                {...onboardingProps}
                downloadFile={downloadFile}
                handleDynamicDocChange={onboardingProps.handleDynamicFileChange}
                dynamicDocErrors={onboardingProps.formError}
            />
          </main>
        </div>
        : <TokenExpired />
      }

    </>
  )
}

export default OnBoarding;